/**
 * Does the public catalog offer drop-ins for this class? (#4968 R11)
 *
 * The toggle decides, and a saved price — including $0, a free drop-in — must be
 * present. A disabled drop-in keeps its saved rate on purpose, so the price alone
 * never means "offered". Used by the catalog's drop-in filter and both badges.
 */
export function isDropInOffered<T extends { drop_in_enabled?: boolean | null; drop_in_rate?: number | null }>(
  program: T,
): program is T & { drop_in_rate: number } {
  const rate = program.drop_in_rate;
  return program.drop_in_enabled === true && typeof rate === 'number' && Number.isFinite(rate) && rate >= 0;
}
